import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import VideoBackground from '../components/VideoBackground';

const leagues = [
  {
    id: 61,
    name: 'LIGUE 1',
    description: [
      "La rentrée du football français",
      "c'est maintenant !"
    ],
    videoUrl: 'https://2points.fr/allsports/wp-content/uploads/2024/11/Ligue1.mp4'
  },
  {
    id: 39,
    name: 'PREMIER LEAGUE',
    description: [
      "Vivez l'intensité du football anglais",
      "comme si vous y étiez"
    ],
    videoUrl: 'https://2points.fr/allsports/wp-content/uploads/2024/11/Premier-League.mp4'
  },
  {
    id: 2,
    name: 'CHAMPIONS LEAGUE',
    description: [
      "Les plus grandes équipes européennes",
      "s'affrontent pour le titre suprême"
    ],
    videoUrl: 'https://2points.fr/allsports/wp-content/uploads/2024/11/ChampionsLeague.mp4'
  }
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen p-4 md:p-8">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="space-y-6"
      >
        {leagues.map((league, index) => (
          <motion.div
            key={league.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.01 }}
            onClick={() => navigate(`/create/football/${league.id}`)}
            className="relative overflow-hidden rounded-2xl h-[200px] md:h-[280px] cursor-pointer group"
          >
            {/* Background Video */}
            <VideoBackground videoUrl={league.videoUrl} />

            {/* Content */}
            <div className="relative h-full p-4 md:p-8 flex flex-col justify-between">
              <div className={`text-left md:text-right ${index % 2 === 0 ? 'md:ml-auto' : ''}`}>
                <h2 className="text-2xl md:text-4xl font-light tracking-wider text-white mb-3">{league.name}</h2>
                <div className="space-y-1">
                  {league.description.map((line, i) => (
                    <p key={i} className="text-white/80 text-sm">{line}</p>
                  ))}
                </div>
              </div>

              <div className={`${index % 2 === 0 ? 'text-left md:text-right' : 'text-left'}`}>
                <button className="bg-white text-black px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors">
                  Crée tes visuels
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Home;